import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import {  PropertyRatingRoutes   } from "../../../routes/HomeRoutes/PropertyRatingRoutes";

export const PropertyRatingLayout = () => (
    <SwitchRoute routes={PropertyRatingRoutes}/>
);